import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Utils } from '../../../../../../utils/utils';
import { BE_ALLOWED_GROUP_FUNCTIONS } from '../../branchexcellence-admin.constants';
import { ExcellenceLeverKpiComponent } from '../excellence-lever-kpi.component';

@Component({
    selector: 'createexcellenceleverkpi-popup',
    templateUrl: './createexcellenceleverkpi-popup.component.html',
    styleUrls: ['./createexcellenceleverkpi-popup.component.less'],
    standalone: false
})
export class CreateExcellenceLeverKpiPopupComponent implements OnInit {

    form!: FormGroup
    accounts: any[] = []
    allAccounts: any[] = []
    excellenceLevers: any[] = []
    allExcellenceLevers: any[] = []
    groupFunctions: string[] = []
    selectedGroupFunction: string | null = null
    subscriptions: any[] = []

    constructor(
        public dialogRef: MatDialogRef<CreateExcellenceLeverKpiPopupComponent>,
        private formBuilder: FormBuilder,
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private toastrService: ToastrService) { }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            excellenceLeverKpiId: [this.data?.ExcellenceLeverKpiId],
            excellenceLever: [{ value: this.data?.ExcellenceLeverId, disabled: !this.data?.ExcellenceLeverId }, Validators.required],
            kpiDefinitionId: [{ value: this.data?.KpiDefinitionId, disabled: !this.data?.KpiDefinitionId }, Validators.required],
        });

        Utils.httpGetAccounts(
            this.http
            , this.baseUrl
            , this
            , function (tthis: CreateExcellenceLeverKpiPopupComponent, data: any[]) {
                tthis.allAccounts = data;
                tthis.accounts = data;
            },
            null
        )

        Utils.httpGetExcellenceLevers(
            this.http
            , this.baseUrl
            , this
            , function (tthis: CreateExcellenceLeverKpiPopupComponent, data: any[]) {
                tthis.allExcellenceLevers = data;
                tthis.excellenceLevers = data;
                const gfsFromLevers = data.map((l: any) => l.GroupFunction).filter((gf: any) => !!gf);
                const gfsFromKpis = tthis.allAccounts.map((k: any) => k.GroupFunction).filter((gf: any) => !!gf);
                tthis.groupFunctions = [...new Set<string>([...gfsFromLevers, ...gfsFromKpis])].filter(gf => BE_ALLOWED_GROUP_FUNCTIONS.includes(gf)).sort((a, b) => a.localeCompare(b));
                if (tthis.data?.ExcellenceLeverId) {
                    const lever = data.find((l: any) => l.ExcellenceLeverId === tthis.data.ExcellenceLeverId);
                    if (lever?.GroupFunction) {
                        tthis.onGroupFunctionChange(lever.GroupFunction);
                    }
                }
            },
            null
        )
    }
    onSubmit() {
        // stop here if form is invalid
        if (this.form)
            if (this.form.invalid) {
                return;
            }

        Utils.httpUpsertExcellenceLeverKpi(
            this.http
            , this.baseUrl
            , this.form.value
            , this
            , function (tthis: CreateExcellenceLeverKpiPopupComponent, result: any) {
                tthis.dialogRef.close({ event: 'submit' });
                if (result) {
                    tthis.toastrService.success('KPI was assigned to the Excellence lever successfully!');
                }
                else
                    tthis.toastrService.error('KPI could not be assigned to Excellence Lever. Please, contact with administrator');
            },
            function (tthis: CreateExcellenceLeverKpiPopupComponent, result: any) {
                tthis.dialogRef.close({ event: 'submit' });
                tthis.toastrService.error('KPI was assigned previously. If not, please, contact with administrator');
            }
        );
    }

    onGroupFunctionChange(gf: string | null) {
        this.selectedGroupFunction = gf;
        this.excellenceLevers = gf
            ? this.allExcellenceLevers.filter((l: any) => l.GroupFunction === gf)
            : this.allExcellenceLevers;
        this.accounts = gf
            ? this.allAccounts.filter((k: any) => k.GroupFunction === gf)
            : this.allAccounts;

        const leverControl = this.form.get('excellenceLever');
        const kpiControl = this.form.get('kpiDefinitionId');

        if (gf) {
            leverControl?.enable();
            kpiControl?.enable();
        } else {
            leverControl?.disable();
            kpiControl?.disable();
        }

        const currentLeverId = leverControl?.value;
        if (currentLeverId && !this.excellenceLevers.some((l: any) => l.ExcellenceLeverId === currentLeverId)) {
            leverControl?.setValue(null);
        }
        const currentKpiId = kpiControl?.value;
        if (currentKpiId && !this.accounts.some((k: any) => k.KpiDefinitionId === currentKpiId)) {
            kpiControl?.setValue(null);
        }
    }

    backButtonHandler(event: any) {
        event.preventDefault();
        this.dialogRef.close();
    }
}
